/**
 * Pure helpers for Admin Settings.
 *
 * Extracted from AdminSettingsPage.tsx (Sub-PR 6.3).
 */

export function generateFormatPreview(format: string | null): string {
  if (!format) return ''
  return format
    .replace('{case_ref}', 'CASE001')
    .replace('{location}', 'SYD')
    .replace('{node_id}', 'WS01')
    .replaceAll(/\{sequence:\d+\}/g, '01')
    .replace('{sequence}', '1')
    .replace('{date:YYYYMMDD}', '20260115')
    .replace('{year}', '2026')
}
